import { Flex, Spacing, Text, ToggleGroup, ToggleGroupItem } from '@billy/design-system'
import { ChangeEvent, ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { SalesReportDateSelection as DateSelection } from '../../../../enums/salesReportDateSelection'
import { useSalesReportFilters } from '../../../../hooks/useSalesReportFilters'
import { useSalesReportVariant } from '../../../../hooks/useSalesReportVariant'

export const SalesReportDateSelection = (): ReactElement | null => {
  const { t } = useTranslation()
  const { salesReportVariant } = useSalesReportVariant()
  const [{ dateSelection = DateSelection.Issue }, setQueryParams] = useSalesReportFilters()

  const items = useMemo<ToggleGroupItem[]>(
    () => [
      {
        label: t('sales_report.sales_overview.table.column.issue_date'),
        value: DateSelection.Issue,
      },
      {
        label: t('sales_report.sales_overview.table.column.payment_date'),
        value: DateSelection.Payment,
      },
    ],
    [t],
  )

  if (salesReportVariant !== 'overview') {
    return null
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value

    if (value === DateSelection.Issue || value === DateSelection.Payment) {
      setQueryParams({ dateSelection: value })
    }
  }

  return (
    <Flex alignItems="center" gap={Spacing.S8}>
      <Text variant="bodySM">{t('sales_report.sales_overview.date_selection.label')}</Text>
      <ToggleGroup items={items} name="sales-report-date-selection" onChange={handleChange} value={dateSelection} />
    </Flex>
  )
}
